import { schema } from 'normalizr';

const entitySchema = new schema.Entity('certificate', undefined, { idAttribute: 'id' });

export default entitySchema;